import script from "./HrCurrencyField.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCurrencyField.vue?vue&type=script&setup=true&lang=js"

import "./HrCurrencyField.vue?vue&type=style&index=0&id=3abefc2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3abefc2c"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
